const uniqueId = (counter => (str = '') => {
  /* eslint-disable-next-line no-param-reassign */
  counter += 1
  return `${str}${counter}`
})(0)

export default uniqueId
